import { Component, OnInit } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { bounceIn } from "src/app/animations/custom.animation";
import type { SwiperOptions } from "swiper/types";
import { SwiperModule } from "swiper/angular";

@Component({
    selector: "app-inbox-optmsg",
    templateUrl: "./inbox-optmsg.component.html",
    styleUrls: ["./inbox-optmsg.component.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [SwiperModule],
})
export class InboxOptmsgComponent implements OnInit {

  constructor(
    private bottomSheet: MatBottomSheetRef<InboxOptmsgComponent>,
    public translate: TranslateService,
    private router: Router
  ) { }

  ngOnInit() {
    /* data */
  }

  public SliderOptions: SwiperOptions = {
    speed: 400,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    slideToClickedSlide: true,
    pagination: { clickable: true },
  };
  goToStore() {
    this.router.navigateByUrl("/mainTabs/tabs/store");
    this.bottomSheet.dismiss();
  }
}
